import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12.1334C2.25 6.74865 6.61522 2.38342 12 2.38342C17.3848 2.38342 21.75 6.74865 21.75 12.1334C21.75 14.5851 20.8451 16.8255 19.351 18.5387C18.5037 16.007 16.3851 14.0578 13.7532 13.4492C14.9409 12.8199 15.75 11.5711 15.75 10.1334C15.75 8.06236 14.0711 6.38342 12 6.38342C9.92893 6.38342 8.25 8.06236 8.25 10.1334C8.25 11.5711 9.05907 12.8199 10.2468 13.4492C7.6149 14.0578 5.49632 16.007 4.649 18.5387C3.15493 16.8255 2.25 14.5851 2.25 12.1334ZM5.88034 19.7241C7.5535 21.0747 9.68231 21.8834 12 21.8834C14.3177 21.8834 16.4465 21.0747 18.1197 19.7241C17.5306 16.8842 15.0145 14.75 12 14.75C8.98546 14.75 6.4694 16.8842 5.88034 19.7241ZM12 7.88342C10.7574 7.88342 9.75 8.89078 9.75 10.1334C9.75 11.3761 10.7574 12.3834 12 12.3834C13.2426 12.3834 14.25 11.3761 14.25 10.1334C14.25 8.89078 13.2426 7.88342 12 7.88342Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
